import * as React from "react"

import { cn } from "@javascript/components/utils"
import { CODE_BLOCK_THEMES, getCodeHighlighter, type CodeBlockLanguage } from "@javascript/code-highlighter"

interface CodeBlockProps {
  code: string
  language?: CodeBlockLanguage
  className?: string
}

function CodeBlock({ code, language, className }: CodeBlockProps) {
  const [html, setHtml] = React.useState<string | null>(null)

  React.useEffect(() => {
    setHtml(null)

    if (!language) return

    let cancelled = false

    getCodeHighlighter()
      .then((highlighter) => {
        if (cancelled) return

        setHtml(
          highlighter.codeToHtml(code, {
            lang: language,
            themes: CODE_BLOCK_THEMES,
            defaultColor: false
          })
        )
      })
      .catch(() => {
        if (!cancelled) setHtml(null)
      })

    return () => {
      cancelled = true
    }
  }, [code, language])

  if (html) {
    return (
      <div
        data-slot="code-block"
        className={cn("shiki-code-block overflow-x-auto rounded-md text-sm", className)}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    )
  }

  return (
    <pre
      data-slot="code-block"
      className={cn("shiki-code-block overflow-x-auto rounded-md bg-muted p-4 text-sm text-foreground", className)}
    >
      <code>{code}</code>
    </pre>
  )
}

export { CodeBlock }
